export default __webpack_public_path__ + "static/media/address.5fa2eb64.png";